/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CvssMetricScoreRangeQueryOperator extends models.AppSecopsScoreRangeQueryOperator {
    constructor() {
        super();
        this.setDiscriminator("CvssMetricScoreRangeQueryOperator");
    }

    getFixupPrototypeFunction() { return CvssMetricScoreRangeQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<CvssMetricScoreRangeQueryOperator>): CvssMetricScoreRangeQueryOperator {
        let obj = Object.assign(new CvssMetricScoreRangeQueryOperator(), model);
        CvssMetricScoreRangeQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CvssMetricScoreRangeQueryOperator>): CvssMetricScoreRangeQueryOperator {
        if (!model) return null;
        return CvssMetricScoreRangeQueryOperator.newInstance(<CvssMetricScoreRangeQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CvssMetricScoreRangeQueryOperator) {
        if (!obj) return;

        models.CvssMetricScoreRangeQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CvssMetricScoreRangeQueryOperator): boolean {
        if (models.AppSecopsScoreRangeQueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CvssMetricScoreRangeQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
